const BASE_URL = process.env.API_HOST
const LOGIN_URL = `${BASE_URL}/account/api`
const EXHIBITOR_URL = `${BASE_URL}/exhibition/api`
const TONGJI_URL = `${BASE_URL}/log/api/`
export { BASE_URL, LOGIN_URL, EXHIBITOR_URL,  TONGJI_URL}



// WEBPACK FOOTER //
// ./src/api/config.js